const Reward = props => (
  <svg
    id="reward"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <style>{'.cls-1{fill:#e82727}.cls-2{fill:#b52424}'}</style>
    </defs>
    <circle
      id="Ellipse_1610"
      data-name="Ellipse 1610"
      className="cls-1"
      cx={12}
      cy={12}
      r={12}
    />
    <path
      id="Path_4428"
      data-name="Path 4428"
      className="cls-2"
      d="M268.1 12A12.062 12.062 0 0 1 256 24V0a12.062 12.062 0 0 1 12.1 12z"
      transform="translate(-243.724)"
    />
    <circle
      id="Ellipse_1611"
      data-name="Ellipse 1611"
      cx={9.989}
      cy={9.989}
      transform="translate(2.384 2.011)"
      style={{
        fill: '#ff9191',
      }}
      r={9.989}
    />
    <path
      id="Path_4429"
      data-name="Path 4429"
      d="M266.087 39.989A10.049 10.049 0 0 1 256 49.979V30a10.049 10.049 0 0 1 10.087 9.989z"
      transform="translate(-243.724 -27.989)"
      style={{
        fill: '#c66161',
      }}
    />
    <circle
      id="Ellipse_1612"
      data-name="Ellipse 1612"
      className="cls-1"
      cx={7.979}
      cy={7.979}
      transform="translate(4.394 4.021)"
      r={7.979}
    />
    <path
      id="Path_4430"
      data-name="Path 4430"
      className="cls-2"
      d="M264.076 67.979A8.037 8.037 0 0 1 256 75.957V60a8.037 8.037 0 0 1 8.076 7.979z"
      transform="translate(-243.676 -55.979)"
    />
    <path
      id="Path_4431"
      data-name="Path 4431"
      d="m171.666 88.972 1.447 2.93 3.236.47a.751.751 0 0 1 .417 1.282l-2.342 2.281.553 3.22a.752.752 0 0 1-1.091.792l-2.894-1.521-2.892 1.521a.752.752 0 0 1-1.091-.792l.553-3.22-2.342-2.281a.751.751 0 0 1 .417-1.282l3.236-.47 1.447-2.93a.752.752 0 0 1 1.346 0z"
      transform="translate(-158.619 -82.618)"
      style={{
        fill: '#ff8989',
      }}
    />
    <path
      id="Path_4432"
      data-name="Path 4432"
      d="m261.868 93.651-2.379 2.281.562 3.221a.761.761 0 0 1-1.109.792L256 98.424V88.55a.757.757 0 0 1 .686.419l1.47 2.93 3.288.47a.748.748 0 0 1 .424 1.282z"
      transform="translate(-243.66 -82.615)"
      style={{
        fill: '#da7171',
      }}
    />
  </svg>
)

export default Reward
